import { QueryKey } from 'react-query';

import { ID } from '../../../../../types';

class UniversalFilterSavedState {
  static getCacheKey({
    viewId,
    fieldName
  }: {
    viewId: ID;
    fieldName: string | number | symbol;
  }): QueryKey {
    return `universal-filter-${viewId}-${String(fieldName)}`;
  }
}

export default UniversalFilterSavedState;
